
import "../Login/Login.css";
import { Link, useParams } from "react-router-dom";
import React, { useEffect } from "react";
import { domain } from "../../../Urls/Services/Api_urls"
import Swal from "sweetalert2";
import Logonew from "../../../assets/LogoNew.webp";

export default function ActivateAccount() {
  const params = useParams();


  


  const urlSearchParams = new URLSearchParams(window.location.search);
  const paramster = Object.fromEntries(urlSearchParams.entries());
  const type = paramster.type;
  const token = paramster.token;

  const url = domain + "/user/" + token + "/ActivateAccount/";
  const url1 = domain + "/directv/" + token + "/activate_account/";
  let urlfetch = '';
  
  const cambiarURL = (e) => {
    if (type === "TPU") {
      urlfetch = url1;
      console.log(params);
    } else {
      urlfetch = url;
    }
  };

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

 
  const ActivateAccount = (event) => {
    event.preventDefault();
    
    try {
    cambiarURL();
    fetch(urlfetch, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(data => data.json())
    .then(async function (data) {
      console.log(data);
      Toast.fire({
        icon: data["type"],
        title: data["msg"]
      })
      setTimeout(function() {
        // Redirecciona al usuario a la página deseada
        window.location.href = '/login';
      }, 3000);
      }
    );
  } catch (error) {
    console.error();
  }

  }
  useEffect(() => {

  }, []);

  return (
    <div>
      <body>
        <section className="derecha15">
          <div style={{ height: 50 }} />
          <div className="contened15">
          <Link to="/">
          <img className="w-32" src={Logonew} alt="" />
              </Link>
              <div style={{ height: 50 }} />
            <div style={{justifyContent: "center", alignItems: "center" }} >
            
                <h5 className="" style={{padding: "1rem"}}>     
                Gracias por verificar tu correo electronico, <br></br>Solo te falta activarla presionando ¡Activar!
                </h5>
           

              </div>

              <div style={{ height: 10 }} />
            <form>

            <div style={{ height: 20 }} />
              <div style={{ height: 20 }} />

              <button className="btn12"  type="button" onClick={ActivateAccount}>
                Activar Cuenta
              </button>
            </form>
          </div>
        </section>
      </body>

   
    </div>
  );
}